import {
    DeviceTypes,
    ChartLabels,
    TabValues,
} from 'components/DeviceDetails/constants';

export const removeSpaces = (str) => {
    return str.replace(/\s/g, '');
};

export const getSnKey = (serialNumber, deviceType) => {
    let serialNumberType = deviceType;
    const serialNumberCleaned = serialNumber?.includes('_')
        ? serialNumber.split('_')[1]
        : serialNumber;

    if (deviceType === DeviceTypes.BMS || deviceType === DeviceTypes.DEFAULT) {
        serialNumberType = DeviceTypes.MASTER;
    } else if (deviceType === DeviceTypes.MODULE) {
        serialNumberType = DeviceTypes.Pack;
    }

    return `${serialNumberCleaned}_${serialNumberType}`;
};

export const getLineLabels = (stats, deviceType, chartType) => {
    let lineLabels = [];
    if (deviceType === DeviceTypes.NEP) {
        lineLabels = stats ? Object.keys(stats) : [];
    } else if (chartType.title === TabValues.Charge) {
        lineLabels = [
            deviceType === DeviceTypes.Pack
                ? ChartLabels.Pack_SOC
                : ChartLabels.Master_SOC,
        ];
    } else if (chartType.title === TabValues.Current) {
        lineLabels = [ChartLabels.Current];
    } else if (chartType.title === TabValues.Voltage) {
        lineLabels = [ChartLabels.Voltage];
    } else if (chartType.title === TabValues.Power) {
        lineLabels = [ChartLabels.Power];
    } else if (chartType.title === TabValues.Temp) {
        lineLabels = [ChartLabels.MinTemp, ChartLabels.MaxTemp];
    } else if (chartType.title === TabValues.All) {
        lineLabels = [
            ChartLabels.MinTemp,
            ChartLabels.MaxTemp,
            ChartLabels.Charge,
            ChartLabels.Current,
            ChartLabels.Voltage,
            ChartLabels.Power,
        ];
    }
    return lineLabels;
};
